import { Icon } from '@nike/eds';
import { Link, useLocation } from 'react-router-dom';
import AdminUserAvatar from './AdminUserAvatar';
import {
  getNavBreadcrumbsByCurrentUrlPath,
  navigationList,
} from '../utils/navigationHelpers';

export default function TopNav() {
  const loc = useLocation();
  const breadcrumbs = getNavBreadcrumbsByCurrentUrlPath(
    navigationList,
    loc.pathname,
  );

  return (
    <nav className='tw-flex tw-justify-between tw-align-middle tw-bg-white'>
      <div className='tw-flex tw-mx-5' aria-label='Breadcrumb'>
        <ol className='tw-inline-flex tw-items-center tw-space-x-1'>
          <li className='tw-inline-flex tw-items-center'>
            <Link to='/' className='tw-inline-flex tw-items-center'>
              <Icon name='HomeStroke' size='s' enableFocus />
            </Link>
          </li>

          {breadcrumbs.map((item) => {
            return (
              <li key={item.id} className='tw-inline-flex tw-items-center'>
                <Icon
                  name='CaretRight'
                  size='m'
                  enableFocus
                  color='var(--eds-color-grey-2)'
                />
                <Link to={item.link}>{item.label}</Link>
              </li>
            );
          })}
        </ol>
      </div>
      <div className='tw-px-8 tw-py-4'>
        <AdminUserAvatar />
      </div>
    </nav>
  );
}
